import styled from 'styled-components'
import { colors } from '../../theme'

// export const Img = styled.img`
//   max-width: 834px;
//   height: 100vh;
// `
export const RealizeSeuLogin = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${colors.grey100};
`
// export const Wrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   flex-direction: column;
//   margin: 0 auto;
// `
export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 40px auto;
  background-color: ${colors.login};
  box-shadow: 0 18px 48px ${colors.overlay};
  border-radius: 20px;
  color: ${colors.white};
  width: 400px;
  padding: 40px;
  gap: 14px;
`

/**
 * Coloca o comunicado de rebranding ao lado do cartao de login, empilhando
 * abaixo dele quando nao cabem lado a lado.
 *
 * O reset da margem do `Wrapper` e obrigatorio, nao cosmetico: o cartao traz
 * `margin: 40px auto` do uso original, em que era o unico filho centralizado.
 * Como item de uma linha flex, as margens automaticas absorvem TODO o espaco
 * livre e ignoram o `justify-content` — o aviso iria para a ponta esquerda e o
 * cartao ficaria centralizado no resto. O respiro vertical volta como padding
 * do container e o horizontal vira o `gap`.
 */
export const AreaLogin = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 28px;
  padding: 40px 20px;
  /* Sem largura definida esta area seria dimensionada pelo proprio conteudo (e
     um item flex do Container), e ai o max-width percentual do aviso resolveria
     contra largura indefinida e nao seguraria nada. */
  width: 100%;

  /* O cartao de login tem largura fixa de 400px e seus campos internos, 320px
     tambem fixos — abaixo de 440px de viewport ele ja estourava, e o padding
     lateral daqui somaria a sobra. Estreitar o cartao NAO e alternativa: os
     320px vazariam para fora dele. Entao o padding lateral sai no celular, e o
     estouro fica igual ao que ja existia antes deste aviso. */
  @media (max-width: 460px) {
    padding: 24px 0;
  }

  ${Wrapper} {
    margin: 0;
  }
`

export const WrapperEsqueciSenha = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 40px auto;
  background-color: ${colors.login};
  box-shadow: 0 18px 48px ${colors.overlay};
  border-radius: 20px;
  color: ${colors.white};
  width: 400px;
  padding: 40px;
  gap: 20px;
`
export const WrapperEmailEnviado = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 40px auto;
  background-color: ${colors.login};
  box-shadow: 0 18px 48px ${colors.overlay};
  border-radius: 20px;
  color: ${colors.white};
  width: 400px;
  padding: 40px;
  gap: 20px;
  > span {
    margin: 0px auto;
  }
`

export const VoltarLogin = styled.div`
  cursor: pointer;
`

/**
 * Bloco de conteudo dentro dos cartoes de "esqueci a senha" e "e-mail
 * enviado". Reproduz a mesma regua do cartao de login (14px); sem isto os
 * elementos so tinham as margens proprias e o campo colava no botao.
 */
export const Bloco = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`

/** Titulo + subtitulo andam juntos, com respiro menor que o do bloco. */
export const TituloGrupo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`
